import { createSlice } from '@reduxjs/toolkit';

// Slice for managing form fields for ניהול תשלומים
export const columnsFormPaymentsManagementSlice = createSlice({
  name: 'columnsPaymentsManagement',
  initialState: {
    data: [
      { id: 1, name: 'paymentDate', label: 'תאריך תשלום', required: true, input: 'date', width: 200, show: true },
      { id: 2, name: 'paymentType', label: 'סוג תשלום', required: true, input: 'selected', width: 200, show: true },
      { id: 3, name: 'customPaymentType', label: 'סוג תשלום מותאם אישית', required: false, input: 'text', width: 200, show: false }, // לשימוש כאשר סוג התשלום הוא 'אחר'
      { id: 4, name: 'paymentAmount', label: 'סכום לתשלום', required: true, input: 'text', width: 200, show: true },
      { id: 5, name: 'receiptDocuments', label: 'מסמכי קבלות', required: true, input: 'multiSelect', width: 250, show: true },
      { id: 6, name: 'isPaymentComplete', label: 'גמר תשלום', required: false, input: 'boolean', width: 150, show: true },
      { id: 7, name: 'locked', label: 'נעול', required: false, input: 'boolean', width: 150, show: false }, // אטריביוט נעול
      { id: 8, name: 'required', label: 'חובה', required: false, input: 'boolean', width: 150, show: false }, // אטריביוט חובה
    ]
  },
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
  },
});

// Slice for managing data records for ניהול תשלומים
export const dataPaymentsManagementSlice = createSlice({
  name: 'dataPaymentsManagement',
  initialState: { data: [] },
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
  },
});

// Exporting actions
export const columnsFormPaymentsManagementActions = columnsFormPaymentsManagementSlice.actions;
export const dataPaymentsManagementActions = dataPaymentsManagementSlice.actions;

